import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import InstallInstructions from '../components/InstallInstructions';
import SimplePwaDebug from '../components/SimplePwaDebug';
import { isMobileDevice } from '../utils/pwa';

const HomePage = ({ installPrompt, onInstallClick }) => {
  const { isAuthenticated } = useAuth();
  
  return (
    <div className="home-page">
      <section className="hero-section">
        <div className="container hero-content">
          <h1 className="hero-title">Help Feed Cats In Need</h1>
          <p className="hero-subtitle">
            Request to feed cats and get notified when they're fed. 
            Make a difference in the lives of cats around you.
          </p>
          
          <div className="hero-buttons">
            {!isAuthenticated && (
              <>
                <Link to="/register" className="button">Get Started</Link>
                <Link to="/login" className="button secondary">Login</Link>
              </>
            )}
            
            {isAuthenticated && (
              <Link to="/cats" className="button">Browse Cats</Link>
            )}
            
            {installPrompt && (
              <button 
                className="button install-button"
                onClick={onInstallClick}
              >
                Install App
              </button>
            )}
          </div>
          
          {/* Show manual install instructions when on mobile */}
          {isMobileDevice() && !installPrompt && (
            <div className="install-instructions-container">
              <InstallInstructions />
            </div>
          )}
        </div>
      </section>
      
      <section className="features-section">
        <div className="container">
          <h2 className="features-title">How It Works</h2>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🐱</div>
              <h3 className="feature-title">Browse Cats</h3>
              <p className="feature-description">
                Discover cats in your area that need food and care.
                See their profiles and get to know them.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🍽️</div>
              <h3 className="feature-title">Request to Feed</h3>
              <p className="feature-description">
                Select a cat and submit a feeding request.
                Each request helps a cat get fed.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🔔</div>
              <h3 className="feature-title">Get Notified</h3>
              <p className="feature-description">
                Receive real-time notifications when your requested
                cat is fed. See photos of happy, well-fed cats.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">📱</div>
              <h3 className="feature-title">Install the App</h3>
              <p className="feature-description">
                Add WellFed Cats to your home screen for quick access
                and a better experience. Enable notifications to stay updated.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🤝</div>
              <h3 className="feature-title">Connect with Feeders</h3>
              <p className="feature-description">
                Follow the people who care for cats in your community.
                Support their efforts.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">💖</div>
              <h3 className="feature-title">Make a Difference</h3>
              <p className="feature-description">
                Every feeding request helps a cat in need. Join our community
                of cat lovers and make a positive impact.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Add simplified PWA Debug Panel for mobile */}
      <SimplePwaDebug />
    </div>
  );
};

export default HomePage; 